export const T = {
  siteTitle: { pt: "POLITICAL WINDOW", en: "POLITICAL WINDOW" },
  siteTagline: {
    pt: "Janela Política — Análise Internacional e Relações Brasil-EUA",
    en: "Janela Política — International Affairs & Brazil-US Relations",
  },
  edition: { pt: "Edição Brasília / Washington", en: "Brasília / Washington Edition" },
  langLabel: { pt: "Português", en: "English" },
  nav: {
    home: { pt: "Início", en: "Home" },
    "brazil-us": { pt: "Brasil-EUA", en: "Brazil-US" },
    "news-analysis": { pt: "Notícias & Análise", en: "News & Analysis" },
    world: { pt: "Mundo", en: "World" },
    interviews: { pt: "Entrevistas", en: "Interviews" },
    opinion: { pt: "Opinião", en: "Opinion" },
    explainers: { pt: "Explicadores", en: "Explainers" },
    search: { pt: "Buscar", en: "Search" },
  },
  labels: {
    lead: { pt: "Reportagem principal", en: "Lead Story" },
    featured: { pt: "Destaques", en: "Featured" },
    latest: { pt: "Últimas", en: "Latest" },
    analysis: { pt: "Análise", en: "Analysis" },
    readMore: { pt: "Ler análise completa", en: "Read full analysis" },
    minRead: { pt: "min de leitura", en: "min read" },
    author: { pt: "Autor", en: "Author" },
    related: { pt: "Cobertura relacionada", en: "Related coverage" },
    section: { pt: "Seção", en: "Section" },
    publishedOn: { pt: "Publicado em", en: "Published" },
    search: { pt: "Buscar artigos, autores, temas...", en: "Search articles, authors, topics..." },
    searchResults: { pt: "Resultados da busca", en: "Search results" },
    noResults: { pt: "Nenhum resultado encontrado.", en: "No results found." },
    all: { pt: "Todos", en: "All" },
    about: { pt: "Sobre", en: "About" },
    contact: { pt: "Contato", en: "Contact" },
    privacy: { pt: "Política de Privacidade", en: "Privacy Policy" },
    terms: { pt: "Termos", en: "Terms" },
    editorial: { pt: "Editorial", en: "Editorial" },
    admin: { pt: "Editor", en: "Editor" },
    login: { pt: "Entrar", en: "Sign in" },
    logout: { pt: "Sair", en: "Sign out" },
    email: { pt: "E-mail", en: "Email" },
    password: { pt: "Senha", en: "Password" },
    submit: { pt: "Enviar", en: "Submit" },
    save: { pt: "Salvar", en: "Save" },
    publish: { pt: "Publicar", en: "Publish" },
    draft: { pt: "Rascunho", en: "Draft" },
    delete: { pt: "Excluir", en: "Delete" },
    edit: { pt: "Editar", en: "Edit" },
    newArticle: { pt: "Novo artigo", en: "New article" },
    translate: { pt: "Traduzir com IA", en: "Translate with AI" },
    summarize: { pt: "Resumir com IA", en: "Summarize with AI" },
    uploadImage: { pt: "Enviar imagem", en: "Upload image" },
    windowMotto: {
      pt: "Uma janela sobre a política mundial e a relação Brasil-EUA.",
      en: "A window on world politics and Brazil-US relations.",
    },
    newsletter: {
      pt: "Assine nossa newsletter editorial semanal",
      en: "Subscribe to our weekly editorial newsletter",
    },
    heroKicker: {
      pt: "Reportagem em destaque",
      en: "Featured reporting",
    },
    contactHeadline: {
      pt: "Fale com a redação",
      en: "Contact the editorial desk",
    },
    contactBlurb: {
      pt: "Envie sugestões de pauta, cartas ao editor ou consultas comerciais.",
      en: "Send story tips, letters to the editor, or business inquiries.",
    },
    aboutHeadline: { pt: "Sobre a Política Window", en: "About Political Window" },
    privacyHeadline: { pt: "Política de Privacidade", en: "Privacy Policy" },
    termsHeadline: { pt: "Termos de Uso", en: "Terms of Use" },
    sent: { pt: "Mensagem enviada. Obrigado.", en: "Message sent. Thank you." },
    name: { pt: "Nome", en: "Name" },
    subject: { pt: "Assunto", en: "Subject" },
    message: { pt: "Mensagem", en: "Message" },
    thisIssue: { pt: "Nesta edição", en: "In this edition" },
    fromTheDesk: { pt: "Da Redação", en: "From the Desk" },
  },
};

export const SECTIONS_ORDER = [
  "brazil-us",
  "news-analysis",
  "world",
  "interviews",
  "opinion",
  "explainers",
];

export const t = (path, lang) => {
  const parts = path.split(".");
  let ref = T;
  for (const p of parts) {
    ref = ref?.[p];
    if (!ref) return path;
  }
  return typeof ref === "object" ? ref[lang] || ref.en : ref;
};
